export default __webpack_public_path__ + "static/quiz-fb4042c5f8b38a14360e32d115d5cb59.png";